import React from 'react'
import { AlignItems, Box, Color, Display, Icon, Text } from '@gousto-internal/citrus-react'

type DietaryWarningTagProps = {
  text: string
}

export function DietaryWarningTag({ text }: DietaryWarningTagProps) {
  return (
    <Box
      data-testid="dietary-warning-tag"
      bg={Color.ColdGrey_900}
      height="24px"
      display={Display.Flex}
      alignItems={AlignItems.Center}
      gap={1}
      maxWidth="100%"
      minWidth="0"
      style={{ borderRadius: '4px' }}
      width="fit-content"
    >
      <Box
        data-testid="info-icon"
        style={{
          borderTopLeftRadius: '4px',
          borderBottomLeftRadius: '4px',
          flexShrink: 0,
        }}
        bg={Color.Warning_700}
        width="22px"
        paddingH={0.75}
        paddingV={1}
        display={Display.Flex}
      >
        <Icon name="info" style={{ color: Color.White }} size={4} />
      </Box>
      <Box data-testid="dietary-warning-text" minWidth="0" paddingRight={2}>
        <Text
          size={2}
          color={Color.White}
          style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {text}
        </Text>
      </Box>
    </Box>
  )
}
